import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

var Base = styled("div").withConfig({
  displayName: "Arrow__Base",
  componentId: "sc-23ct68-0"
})(["position:absolute;width:", "px;height:", "px;background:", ";"], function (props) {
  return props.width;
}, function (props) {
  return props.width;
}, function (props) {
  return props.background;
});

var Up = styled(Base).withConfig({
  displayName: "Arrow__Up",
  componentId: "sc-23ct68-1"
})(["transform:translateX(-50%) translateY(50%) rotateZ(45deg);bottom:100%;left:50%;border-left:1px solid ", ";border-top:1px solid ", ";"], function (props) {
  return props.border;
}, function (props) {
  return props.border;
});
var Down = styled(Base).withConfig({
  displayName: "Arrow__Down",
  componentId: "sc-23ct68-2"
})(["transform:translateX(-50%) translateY(-50%) rotateZ(45deg);top:100%;left:50%;border-right:1px solid ", ";border-bottom:1px solid ", ";"], function (props) {
  return props.border;
}, function (props) {
  return props.border;
});
var Left = styled(Base).withConfig({
  displayName: "Arrow__Left",
  componentId: "sc-23ct68-3"
})(["transform:translateX(50%) translateY(-50%) rotateZ(45deg);right:100%;top:50%;border-left:1px solid ", ";border-bottom:1px solid ", ";"], function (props) {
  return props.border;
}, function (props) {
  return props.border;
});

var Right = styled(Base).withConfig({
  displayName: "Arrow__Right",
  componentId: "sc-23ct68-4"
})(["transform:translateX(-50%) translateY(-50%) rotateZ(45deg);left:100%;top:50%;border-right:1px solid ", ";border-top:1px solid ", ";"], function (props) {
  return props.border;
}, function (props) {
  return props.border;
});

var arrows = {
  left: Right,
  top: Down,
  right: Left,
  bottom: Up
};

var Arrow = function Arrow(_ref) {
  var background = _ref.background,
      border = _ref.border,
      placement = _ref.placement,
      width = _ref.width;

  var Component = arrows[placement] || arrows.top;
  return width > 0 && React.createElement(Component, { background: background, border: border, width: width });
};

Arrow.propTypes = process.env.NODE_ENV !== "production" ? {
  background: PropTypes.string.isRequired,
  border: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired
} : {};

export default Arrow;